module.exports = __webpack_public_path__ + "assets/icons/ic_feedback_24px.svg";